import entities from "./entities";
import systemAdminIndex from "./index/index";
import invites from "./invites";
import reverseShipmentQuantities from "./reverseShipmentQuantities";
import fixOpenQuantities from "./fixOpenQuantities";

const modules = [systemAdminIndex, entities, invites, reverseShipmentQuantities, fixOpenQuantities];

export default modules;
